var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.openModal)?_c('div',{staticClass:"preview-shadow",on:{"click":_vm.close}},[_c('div',{staticClass:"image-content"},[_c('img',{attrs:{"alt":"","src":_vm.path}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }